import React from "react";

/**
 * Chevron-down icon (Figma style). Stroke-based, accepts color and size.
 */
export default function DownArrowChevron({ color = "currentColor", size = "18", className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.5 6.75L9 11.25L13.5 6.75"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
